import React, {Component} from 'react';
import PropTypes from 'prop-types';
import tiktok from '../img/icon_tiktok.png'
import web from "../img/webber.png"
import weiChat from '../img/icon_weichat.png'
import weiBo from '../img/icon_weibo.png'
import kuaishou from '../img/kuaishou.png'
import other from '../img/other.png'
export const configImgList = {
    1:web,
    2:weiChat,
    3:weiBo,
    4:tiktok,
    5:kuaishou,
    "-1":other
};
